import {getSingularEntityType} from 'nutshell-core/utils/get-singular-entity-type';
import {getTypeFromApiId} from 'nutshell-core/utils/get-type-from-api-id';

export function getSeeMoreText(totalCount: number, maxDisplayedBeforeSeeMore: number) {
    return `+${totalCount - maxDisplayedBeforeSeeMore} more`;
}

export function getEntityLabel(apiId?: string | null) {
    if (!apiId) {
        return 'attendee';
    }

    const entityType = getTypeFromApiId(apiId);

    if (!entityType) {
        return 'attendee';
    }

    return getSingularEntityType(entityType);
}
